import numeral from 'numeral';

// ----------------------------------------------------------------------
export const localDecimalSeparator = () =>
    1.1.toLocaleString().substring(1, 2);

export const localThousandSeparator = () =>
    localDecimalSeparator() === '.' ? ',' : '.'

export const gNumberFromLocaleString = (value: string) => {
    const localThousandSeparatorValue = localThousandSeparator();
    const localDecimalSeparatorValue = localDecimalSeparator();
    return parseFloat(value.replace(new RegExp(localThousandSeparatorValue === '.' ? '\\.' : localThousandSeparatorValue, 'g'), '').replace(localDecimalSeparatorValue, '.'));
}
    

export function fCurrency(number: string | number, precision: number, currency: string = '$') {
    return `${fFixed(number, precision)} $`.replace('$', currency);
}

export function fFixed(number: string | number, precision: number = 0) {
    const localDecimal = localDecimalSeparator();
    const localThousand = localThousandSeparator();
    const value = (precision || precision === 0 ? numeral(number).format((1 / Math.pow(10, precision)).toString()) : `${numeral(number).format('0,0.00')}`).replace('.', localDecimal);
    const split = value.toString().split(localDecimal);

    return `${split[0].replace(/\B(?=(\d{3})+(?!\d))/g, localThousand)}${split.length > 0 && precision !== 0 ? `${localDecimal}${split[1]}` : ''}`;
}
export const fInt = (number: string | number) => fFixed(number, 0);

export function sCurrencyUnits(currency: string = '', um: string | undefined = undefined) {
    return `${currency}${um ? `/${um}` : ''}`;
}

export function fPercent(number: number, precision: number = 0) {
    return `${fFixed(number, precision)} %`;
}

export function fNumber(number: string | number) {
    return numeral(number).format();
}

export function fShortenNumber(number: string | number) {
    return numeral(number).format('0.00a').replace('.00', '');
}

export function fData(number: string | number) {
    return numeral(number).format('0.0 b');
}

export function hasNumberValue(value: any) {
    return typeof value === 'number' && (!!value || value === 0);
}

export function numberRound(value: number, precision: number = 0): number{
    return Math.round(value * Math.pow(10, precision)) / Math.pow(10, precision);
}